<template>
    <div
        class="bigdata_container"
        id="bigdata"
        v-loading="isLoading"
        element-loading-text="拼命加载中..."
        element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div class="header">
            {{ this.$store.state.info.orgName }}适老化管理可视化平台
        </div>
        <div class="quanp">
            <el-button id="fullScreen" @click="showFullScreen" type="primary">{{
                onFullScreen ? "退出全屏" : "进入全屏"
            }}</el-button>
        </div>
        <transition name="nameoftransition">
            <div class="info_tisp" v-show="infoTisp">
                <i class="el-message__icon el-icon-info"></i>未搜索到相关数据
            </div>
        </transition>
        <div class="bigdata_main">
            <div class="main_left">
                <div class="main_pane main_pane1">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <img src="../assets/img/title_icon.png" alt="" />
                        </div>
                        <div class="titleTxt">项目状态</div>
                    </div>
                    <div class="titleBox">
                        <ul>
                            <li>
                                <div
                                    class="bgimg"
                                    @click="handleSearch('type', 1)"
                                >
                                    {{ state.distribute }}
                                </div>
                                <p>分配</p>
                            </li>
                            <li>
                                <div
                                    class="bgimg"
                                    @click="handleSearch('type', 2)"
                                >
                                    {{ state.assessApproval }}
                                </div>
                                <p>评估审核</p>
                            </li>
                            <li>
                                <div
                                    class="bgimg"
                                    @click="handleSearch('type', 4)"
                                >
                                    {{ state.constructionApproval }}
                                </div>
                                <p>施工督查</p>
                            </li>
                            <li>
                                <div
                                    class="bgimg"
                                    @click="handleSearch('type', 6)"
                                >
                                    {{ state.toBeEvaluate }}
                                </div>
                                <p>评价完成</p>
                            </li>
                            <li>
                                <div
                                    class="bgimg"
                                    @click="handleSearch('type', 7)"
                                >
                                    {{ state.finishEvaluate }}
                                </div>
                                <p>回访工单</p>
                            </li>
                            <li>
                                <div
                                    class="bgimg"
                                    @click="handleSearch('type', 8)"
                                >
                                    {{ state.completed }}
                                </div>
                                <p>完工</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 老人类别统计 -->
                <div class="main_pane main_pane2" style="margin-top: 20px">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <img src="../assets/img/title_icon.png" alt="" />
                        </div>
                        <div class="titleTxt">类别统计</div>
                    </div>
                    <div class="titleBox">
                        <div
                            id="echartsOne"
                            ref="echartsOne"
                            style="height: 100%; width: 100%"
                        ></div>
                    </div>
                </div>
                <!-- 改造人数统计 -->
                <div class="main_pane main_pane3" style="margin-top: 20px">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <img src="../assets/img/title_icon.png" alt="" />
                        </div>
                        <div class="titleTxt">改造人数统计</div>
                    </div>
                    <div class="titleBox">
                        <div
                            id="echartsTwo"
                            ref="echartsTwo"
                            style="height: 100%; width: 100%"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="main_center">
                <!-- 地图分析 -->
                <div class="map">
                    <span class="title_wrap">地图分析</span>
                    <div class="serach_wrapper">
                        <el-input
                            v-model="keyword"
                            placeholder="请输入姓名"
                            style="width: 120px; margin-right: 12px"
                        ></el-input
                        ><el-button
                            type="primary"
                            @click="handleSearch('search')"
                            >搜索</el-button
                        >
                    </div>
                    <div id="container" style="width: 100%; height: 100%"></div>
                </div>
                <div class="map">
                    <span class="title_wrap">改造信息</span>
                    <div class="update_info">
                        <div class="info_left">
                            <div class="left_title">
                                <span>序号</span>
                                <span>姓名</span>
                                <span>居住地址</span>
                            </div>
                            <div class="wrapper">
                                <div
                                    class="left_list"
                                    v-for="(item, index) in formationInfoList"
                                    :key="index"
                                    @click="changePhoto(item)"
                                >
                                    <p
                                        class="list_item"
                                        :title="index"
                                        style="
                                            flex: 0 0 60px;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                        "
                                    >
                                        <span class="index">{{
                                            index + 1
                                        }}</span>
                                    </p>
                                    <p
                                        class="list_item"
                                        :title="item.customerName"
                                    >
                                        {{ item.customerName }}
                                    </p>
                                    <p
                                        class="list_item"
                                        :title="item.detailAddress"
                                    >
                                        {{ item.detailAddress }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="info_right">
                            <el-carousel
                                arrow="always"
                                style="height: 100%"
                                :autoplay="true"
                                indicator-position="none"
                            >
                                <el-carousel-item
                                    v-for="(
                                        item, index
                                    ) in elderlySubProManageList"
                                    :key="index"
                                >
                                    <div class="wrapper">
                                        <div class="left">
                                            <p class="label">改造前</p>
                                            <img :src="item.before" alt="" />
                                        </div>
                                        <div class="right">
                                            <p class="label">改造后</p>
                                            <img :src="item.after" alt="" />
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </div>
            </div>

            <div class="main_right">
                <!-- 改造项目统计 -->
                <div class="main_pane main_pane4">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <img src="../assets/img/title_icon.png" alt="" />
                        </div>
                        <div class="titleTxt">改造项目统计</div>
                    </div>
                    <div class="titleBox">
                        <div
                            id="echartsThree"
                            ref="echartsThree"
                            style="height: 100%; width: 100%; padding-top: 30px"
                        ></div>
                    </div>
                </div>
                <!-- 自理类别统计 -->
                <div class="main_pane main_pane5" style="margin-top: 20px">
                    <div class="titleHeader">
                        <div class="titleIcon">
                            <img src="../assets/img/title_icon.png" alt="" />
                        </div>
                        <div class="titleTxt">自理类别统计</div>
                    </div>
                    <div class="titleBox">
                        <div
                            id="echartsFour"
                            ref="echartsFour"
                            style="height: 100%; width: 100%"
                        ></div>
                    </div>
                </div>
                <!-- 改造完工评价 -->
                <div class="main_pane main_pane6" style="margin-top: 20px">
                    <div class="titleHeader iconimg">
                        <div class="titleIcon">
                            <img src="../assets/img/title_icon.png" alt="" />
                        </div>
                        <div class="titleTxt">改造完工评价</div>
                    </div>
                    <div class="titleBox flex1">
                        <div
                            class="li"
                            v-for="(item, index) in textList"
                            :key="index"
                        >
                            <div class="img">{{ index + 1 }}</div>
                            <div class="txt" :title="item.reason">
                                {{ item.reason }}
                            </div>
                            <div
                                class="time"
                                :title="item.evaluateTime | formatDate"
                            >
                                {{ item.evaluateTime | formatDate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- :before-close="handleClose" -->
        <el-dialog
            title="查看"
            :visible.sync="dialogVisible"
            width="990px"
            class="dialog_container"
            @close="dialogVisibleClose"
            ><div id="el-step">
                <el-steps :active="stepIndex" align-center>
                    <el-step @click.native="changeStep(1)"
                        ><span slot="icon">基本信息</span></el-step
                    >
                    <el-step
                        @click.native="changeStep(2)"
                        v-if="
                            currentApprovalStatus >= 4 &&
                            currentApprovalStatus != 9 &&
                            currentApprovalStatus != 10 &&
                            currentApprovalStatus != 12
                        "
                        ><span slot="icon">改造信息</span></el-step
                    >
                    <el-step
                        @click.native="changeStep(3)"
                        v-if="currentApprovalStatus == 8"
                        ><span slot="icon">老人评价</span></el-step
                    >
                </el-steps>
            </div>
            <!-- 基本信息 -->
            <div class="dialog_content_pane" v-show="stepIndex == 1">
                <el-form
                    label-width="100px"
                    :model="formData"
                    ref="formData"
                    disabled
                >
                    <el-row>
                        <el-col :span="24">
                            <el-row
                                style="
                                    display: flex;
                                    align-items: end;
                                    margin-bottom: 20px;
                                "
                                class="user_info"
                            >
                                <el-col :span="18">
                                    <el-row class="dialog_form_left">
                                        <el-col :span="11">
                                            <el-form-item label="姓名：">
                                                <el-input
                                                    v-model="
                                                        formData.customerName
                                                    "
                                                ></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="11" :offset="2">
                                            <el-form-item label="性别：">
                                                <el-input
                                                    v-model="formData.gender"
                                                ></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-form-item label="联系方式：">
                                                <el-input
                                                    v-model="formData.phone"
                                                ></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="11" :offset="2">
                                            <el-form-item label="身份证号：">
                                                <el-input
                                                    v-model="formData.idCard"
                                                ></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-form-item label="年龄：">
                                                <el-input
                                                    v-model="formData.age"
                                                ></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="11" :offset="2">
                                            <el-form-item label="老人类别：">
                                                <el-input
                                                    v-model="
                                                        formData.elderlyBelongCategory
                                                    "
                                                ></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col
                                    :span="6"
                                    style="
                                        display: flex;
                                        flex-direction: column;
                                        align-items: flex-end;
                                    "
                                >
                                    <div class="photo" style="height: 170px">
                                        <img :src="imageUrl" v-if="imageUrl" />
                                        <img
                                            src="../assets/img/photos.png"
                                            v-else
                                        />
                                    </div>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!-- 改造信息 -->
            <div class="dialog_content_pane" v-show="stepIndex == 2">
                <el-form label-width="120px" :disabled="true">
                    <el-form-item label="评估确认单" class="check_form_item">
                        <div class="check_upload">
                            <div class="avatar-uploader">
                                <div class="photo">
                                    <img
                                        :src="checkForm.assessConfirmation"
                                        v-if="checkForm.assessConfirmation"
                                    />
                                    <img src="../assets/img/user.png" v-else />
                                </div>
                            </div>
                            <el-button
                                size="small"
                                type="primary"
                                style="margin-top: 20px; width: 100%"
                                >评估单</el-button
                            >
                        </div>
                    </el-form-item>
                    <el-form-item label="改造项目：" class="check_form_item">
                        <div class="assessment_upload">
                            <ul>
                                <li>
                                    <div class="avatar-uploader">
                                        <img
                                            :src="checkForm.balconyPhoto"
                                            v-if="checkForm.balconyPhoto"
                                        />
                                        <img
                                            src="../assets/img/user.png"
                                            v-else
                                        />
                                    </div>
                                    <el-button
                                        size="small"
                                        type="primary"
                                        style="box-sizing: border-box"
                                        >阳台改造前</el-button
                                    >
                                </li>
                                <li>
                                    <div class="avatar-uploader">
                                        <img
                                            :src="checkForm.balconyAfterPhoto"
                                            v-if="checkForm.balconyAfterPhoto"
                                        />
                                        <img
                                            src="../assets/img/user.png"
                                            v-else
                                        />
                                    </div>
                                    <el-button
                                        size="small"
                                        type="primary"
                                        style="box-sizing: border-box"
                                        >阳台改造后</el-button
                                    >
                                </li>
                                <li>
                                    <div class="avatar-uploader">
                                        <img
                                            :src="checkForm.bedroomPhoto"
                                            v-if="checkForm.bedroomPhoto"
                                        />
                                        <img
                                            src="../assets/img/user.png"
                                            v-else
                                        />
                                    </div>
                                    <el-button
                                        size="small"
                                        type="primary"
                                        style="box-sizing: border-box"
                                        >卧室改造前</el-button
                                    >
                                </li>
                                <li>
                                    <div class="avatar-uploader">
                                        <img
                                            :src="checkForm.bedroomAfterPhoto"
                                            v-if="checkForm.bedroomAfterPhoto"
                                        />
                                        <img
                                            src="../assets/img/user.png"
                                            v-else
                                        />
                                    </div>
                                    <el-button
                                        size="small"
                                        type="primary"
                                        style="box-sizing: border-box"
                                        >卧室改造后</el-button
                                    >
                                </li>
                                <li>
                                    <div class="avatar-uploader">
                                        <img
                                            :src="checkForm.kitchenPhoto"
                                            v-if="checkForm.kitchenPhoto"
                                        />
                                        <img
                                            src="../assets/img/user.png"
                                            v-else
                                        />
                                    </div>
                                    <el-button
                                        size="small"
                                        type="primary"
                                        style="box-sizing: border-box"
                                        >厨房改造前</el-button
                                    >
                                </li>
                                <li>
                                    <div class="avatar-uploader">
                                        <img
                                            :src="checkForm.kitchenAfterPhoto"
                                            v-if="checkForm.kitchenAfterPhoto"
                                        />
                                        <img
                                            src="../assets/img/user.png"
                                            v-else
                                        />
                                    </div>
                                    <el-button
                                        size="small"
                                        type="primary"
                                        style="box-sizing: border-box"
                                        >厨房改造后</el-button
                                    >
                                </li>
                                <li>
                                    <div class="avatar-uploader">
                                        <img
                                            :src="checkForm.livingRoomPhoto"
                                            v-if="checkForm.livingRoomPhoto"
                                        />
                                        <img
                                            src="../assets/img/user.png"
                                            v-else
                                        />
                                    </div>
                                    <el-button
                                        size="small"
                                        type="primary"
                                        style="box-sizing: border-box"
                                        >客厅改造前</el-button
                                    >
                                </li>
                                <li>
                                    <div class="avatar-uploader">
                                        <img
                                            :src="
                                                checkForm.livingRoomAfterPhoto
                                            "
                                            v-if="
                                                checkForm.livingRoomAfterPhoto
                                            "
                                        />
                                        <img
                                            src="../assets/img/user.png"
                                            v-else
                                        />
                                    </div>
                                    <el-button
                                        size="small"
                                        type="primary"
                                        style="box-sizing: border-box"
                                        >客厅改造后</el-button
                                    >
                                </li>
                                <li>
                                    <div class="avatar-uploader">
                                        <img
                                            :src="checkForm.toiletPhoto"
                                            v-if="checkForm.toiletPhoto"
                                        />
                                        <img
                                            src="../assets/img/user.png"
                                            v-else
                                        />
                                    </div>
                                    <el-button
                                        size="small"
                                        type="primary"
                                        style="box-sizing: border-box"
                                        >卫生间改造前</el-button
                                    >
                                </li>
                                <li>
                                    <div class="avatar-uploader">
                                        <img
                                            :src="checkForm.toiletAfterPhoto"
                                            v-if="checkForm.toiletAfterPhoto"
                                        />
                                        <img
                                            src="../assets/img/user.png"
                                            v-else
                                        />
                                    </div>
                                    <el-button
                                        size="small"
                                        type="primary"
                                        style="box-sizing: border-box"
                                        >卫生间改造后</el-button
                                    >
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                    <!-- <template v-for="(item,index) in checkForm.elderlySubProManageList">
            <el-form-item :label="item.productName" class="check_form_item" :key="index">
              <div class="check_upload">
                <div class="avatar-uploader">
                  <div class="avatar">
                    <img :src="item.reformBeforePhoto"  v-if="item.reformBeforePhoto"/>
                    <img src="../assets/img/user.png" v-else/>
                  </div>
                </div>
                <el-button
                  size="small"
                  type="primary"
                  style="width: 100px; margin-top: 20px"
                  >改造前</el-button
                >
              </div>
              <div class="check_upload">
                <div class="avatar-uploader">
                  <div class="avatar">
                    <img :src="item.reformAfterPhoto"  v-if="item.reformAfterPhoto"/>
                    <img src="../assets/img/user.png" v-else/>
                  </div>
                </div>
                <el-button
                  size="small"
                  type="primary"
                  style="width: 100px; margin-top: 20px"
                  >改造后</el-button
                >
              </div>
            </el-form-item>
          </template> -->
                    <!-- <el-form-item label="一字扶手" class="check_form_item">
            <div class="check_upload">
              <div class="avatar-uploader">
                <div class="photo">
                  <img :src="checkForm.straightArmrestBefore" v-if="checkForm.straightArmrestBefore"/>
                  <img src="../assets/img/user.png" v-else/>
                </div>
              </div>
              <el-button size="small" type="primary" style="margin-top: 20px">改造前</el-button >
            </div>
            <div class="check_upload">
              <div class="avatar-uploader">
                <div class="photo">
                  <img :src="checkForm.straightArmrestAfter" v-if="checkForm.straightArmrestAfter"/>
                  <img src="../assets/img/user.png" v-else/>
                </div>
              </div>
              <el-button size="small" type="primary" style="margin-top: 20px">改造后</el-button>
            </div>
          </el-form-item>
          <el-form-item label="烟雾报警器" class="check_form_item">
            <div class="check_upload">
              <div class="avatar-uploader">
                <div class="photo">
                  <img :src="checkForm.smokeDetectorBefore" v-if="checkForm.smokeDetectorBefore"/>
                  <img src="../assets/img/user.png" v-else/>
                </div>
              </div>
              <el-button size="small" type="primary" style="margin-top: 20px">改造前</el-button>
            </div>
            <div class="check_upload">
              <div class="avatar-uploader">
                <div class="photo">
                  <img :src="checkForm.smokeDetectorAfter" v-if="checkForm.smokeDetectorAfter"/>
                  <img src="../assets/img/user.png" v-else/>
                </div>
              </div>
              <el-button size="small" type="primary" style="margin-top: 20px">改造后</el-button>
            </div>
          </el-form-item> -->
                    <el-form-item label="施工单位：">
                        <el-input
                            v-model="checkForm.serviceProviderName"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="施工负责人：">
                        <el-input v-model="checkForm.leader"></el-input>
                    </el-form-item>
                    <el-form-item label="施工员：">
                        <!-- <p>{{ checkForm.serviceProviderPersonList }}</p> -->
                        <el-checkbox-group
                            v-model="checkForm.serviceProviderPersonId"
                        >
                            <el-checkbox
                                :label="item.id"
                                :name="item.id"
                                v-for="(item, index) in providerPersonList"
                                :key="index"
                                >{{ item.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 老人评价 -->
            <div class="dialog_content_pane" v-show="stepIndex == 3">
                <el-form label-width="120px" :disabled="true">
                    <template v-if="elderlyInformationList.length > 0">
                        <template
                            v-for="(item, index) in elderlyInformationList"
                        >
                            <div :key="index">
                                <el-form-item label="问题：">
                                    <el-input
                                        v-model="item.questionName"
                                        placeholder="请输入问题"
                                        :disabled="true"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="回复选择：">
                                    <el-radio-group
                                        v-model="item.replySelection"
                                        :disabled="true"
                                    >
                                        <el-radio label="0">是</el-radio>
                                        <el-radio label="1">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item
                                    label="原因："
                                    placeholder="请输入内容"
                                >
                                    <el-input
                                        type="textarea"
                                        :rows="3"
                                        v-model="item.reason"
                                        :disabled="true"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </template>
                    </template>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="primary" @click="submitForm">确 定</el-button> -->
                <el-button @click="dialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
export default {
    name: "visualized",
    data() {
        return {
            infoTisp: false,
            isLoading: false,
            keyword: "", //搜索
            onFullScreen: false, // 是否全屏
            state: {
                //项目状态
                distribute: "",
                assessApproval: "",
                constructionApproval: "",
                toBeEvaluate: "",
                finishEvaluate: "",
                completed: "",
            },
            echartOne: null, // 老人类别统计echarts
            echartTwo: null, // 改造人数统计echarts
            echartThree: null, // 改造产品统计echarts
            echartFour: null, // 自理类别统计echarts
            personNum: [],
            productName: [],
            productDate: [],
            selfDate: [],
            oldService: [],
            providerPersonList: [],
            textList: [], //老人评价
            map: null, //地图实例
            formationInfoList: [], //改造信息列表
            markers: [], //地图标记点
            dialogVisible: false,
            stepIndex: 1,
            dialogTitle: "",
            formData: {
                name: "",
                sex: "",
                age: "",
                idCode: "",
                phone: "",
                olderType: "",
            },
            // 图片预览
            dialogImageUrl: "",
            nameList: [],
            seriesData: [],
            // 上传图片地址
            actionUrl:
                baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
            imageUrl: "",
            checkForm: {
                assessConfirmation: "", //评估单
                straightArmrestBefore: "", //扶手改造前
                straightArmrestAfter: "", //扶手改造后
                smokeDetectorBefore: "", //烟雾报警器改造前
                smokeDetectorAfter: "", //烟雾报警器改造后
                leader: "", //负责人
                serviceProviderName: "", //负责单位
                balconyPhoto: "", //阳台
                bedroomPhoto: "", //卧室
                kitchenPhoto: "", //厨房
                livingRoomPhoto: "", //客厅
                toiletPhoto: "", //卫生间
                balconyAfterPhoto: "", //阳台改造后
                bedroomAfterPhoto: "", //卧室改造后
                kitchenAfterPhoto: "", //厨房改造后
                livingRoomAfterPhoto: "", //客厅改造后
                toiletAfterPhoto: "", //卫生间改造后
                serviceProviderPersonId: [],
            },
            elderlyInformationList: [], //完工列表list
            oldTypeList: [],
            providerPersonList: [], //施工员列表
            providerList: [], //服务商列表
            currentApprovalStatus: "",
            elderlySubProManageList: [], //
        }
    },
    created() {
        // this.gettypeList()
    },
    filters: {
        //时间格式化
        formatDate(date) {
            let dt = new Date(date)
            let dty = dt.getFullYear()
            let dtm = (dt.getMonth() + 1).toString().padStart(2, "0")
            let dtd = dt.getDate().toString().padStart(2, "0")
            let dth = dt.getHours().toString().padStart(2, "0")
            let dtmi = dt.getMinutes().toString().padStart(2, "0")
            let dts = dt.getSeconds().toString().padStart(2, "0")
            return dty + "-" + dtm + "-" + dtd
        },
    },
    _methods: {
        gettypeList() {
            let query = {
                pageNum: 1,
                pageSize: 999,
                dictType: "customer.type",
            }
            this.$http
                .request({
                    url: "/rbac/system/dict/data/list",
                    method: "get",
                    params: query,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.rows != null) {
                            this.oldTypeList = res.rows
                            this.oldTypeList.forEach((item) => {
                                item.dictCode = String(item.dictCode)
                            })
                        }
                    }
                })
        },
        dialogVisibleClose() {
            this.stepIndex = 1
            this.checkForm.assessConfirmation = "" //评估单
            this.checkForm.straightArmrestBefore = "" //扶手改造前
            this.checkForm.straightArmrestAfter = "" //扶手改造后
            this.checkForm.smokeDetectorBefore = "" //烟雾报警器改造前
            this.checkForm.smokeDetectorAfter = "" //烟雾报警器改造后
            this.checkForm.leader = "" //负责人
            this.checkForm.serviceProviderName = "" //负责单位
            this.checkForm.balconyPhoto = "" //阳台
            this.checkForm.bedroomPhoto = "" //卧室
            this.checkForm.kitchenPhoto = "" //厨房
            this.checkForm.livingRoomPhoto = "" //客厅
            this.checkForm.toiletPhoto = "" //卫生间
            this.checkForm.balconyAfterPhoto = "" //阳台改造后
            this.checkForm.bedroomAfterPhoto = "" //卧室改造后
            this.checkForm.kitchenAfterPhoto = "" //厨房改造后
            this.checkForm.livingRoomAfterPhoto = "" //客厅改造后
            this.checkForm.toiletAfterPhoto = "" //卫生间改造后
        },
        // 步骤条跳转
        changeStep(val) {
            this.stepIndex = val
        },

        submitForm() {},
        handlePicturePreview(file) {
            this.dialogVisible1 = true
            this.dialogImageUrl = file.url
        },
        // 图片上传 end
        // 弹框
        async handleClick(title, row = {}) {
            let self = this
            self.dialogTitle = title
            self.dialogVisible = true
            switch (self.stepIndex) {
                case 1:
                    break
                case 2:
                    break
                case 3:
                    break
            }
        },
        // 控制全屏展示
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        FullCreeen(element) {
            let el = document.getElementById("bigdata")
            let rfs =
                el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullScreen
            if (typeof rfs != "undefined" && rfs) {
                rfs.call(el)
            } else if (typeof window.ActiveXObject != "undefined") {
                let wscript = new ActiveXObject("WScript.Shell")
                if (wscript != null) {
                    wscript.SendKeys("{F11}")
                }
            }
        },
        // 老人类别统计echarts
        echartsOne(trafficWay = []) {
            let self = this
            self.echartOne = self.$echarts.init(
                document.getElementById("echartsOne")
            )
            var img =
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMYAAADGCAYAAACJm/9dAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAE/9JREFUeJztnXmQVeWZxn/dIA2UgsriGmNNrEQNTqSio0IEFXeFkqi4kpngEhXjqMm4MIldkrE1bnGIMmPcUkOiIi6gJIragLKI0Songo5ZJlHGFTADaoRuhZ4/nnPmnO4+l+7bfc85d3l+VV18373n3Ptyvve53/5+da1L6jDdYjgwBhgNHALMBn6Sq0VdcxlwGvACsAx4HliTq0VlRlNzY+LrfTO2o5LoDxwOHAmMA/4WiP+KzM3DqCJpAA4K/i4F2oBXgWbgWWAxsDEv48oZC6M9Q4EJwInAMcDAfM0pOXXA14K/y4FPgQXAfOBxYF1+ppUXFgYMBiYCp6PaoU+B694HFqEmyVJgVSbW9Y6bgCeBb6Am4GHALrH3B6L/+0RgM6pFHgQeAzZkaWi5UVejfYx64AjgXOAk1OToSCtqajyFHGZlVsalzH7oB+BYJJR+Cde0oKbi3cBCYEtWxmVNoT5GrQljGHAecD7wxYT3P0bNirlIEB9lZ1ouDEICOQk1H7dLuOYt4C7gZ8Da7EzLhloXxv7AJcCZdK4dWpAIHkDt7FrtjA5A/aszkFiSntP9wAzgP7M1LT0KCaM+YzuyZixy+leAb9O+sN9AHdDd0S/mbGpXFKD/+2z0LHZHz+aN2PsN6Bm+gjrsY7M2MEuqVRhHoU7yYjS6FPI5MAc4FNgHzUN4JKYz69Cz2Qc9qzno2YUcjZ7t8iBddVSbMEYDzwFPA6Nir28Afgx8CZiERpVM91iKntnfoGcYH606BNUez6GRr6qhWoSxF/AoKsQxsdfXAj9AHe2rgNXZm1Y1/A96hl8E/pn2HfExwBJUBntlb1rpqXRhbA/cDLyGxuJDPgSuBPYErqPGx+RLzAagCT3bK9GzDpmIyuJmVDYVS6UKow74e+APwPeIxuI/AX6Emkw3opldkw6fome8F3rmnwSv90Nl8gdURhU57FmJwtgHdfx+jpZwgCag7gW+DFyDa4gsWY+e+ZdRGYSTgUNRGS1GZVZRVJIwtgF+iMbQ4/2IF4ADgHOA93Kwy4j3UBkcgMokZAwqsx+iMqwIKkUYI4AXgelEzab1wAVoNOSVnOwynXkFlckFqIxAZTYdleGInOwqinIXRh1wMfASMDL2+hxgb+BOqngdTwWzBZXN3qisQkaisryYMu97lLMwhgHzgJ+ivRGgIcJJwd8HOdllus8HROUVDu/2R2U6D5VxWVKuwjgEVcnjY689jqrhOYl3mHJmDiq7x2OvjUdlfEguFnVBOQrju2gmdbcgvwmYitbweFtm5bIGleFUVKagMn4OlXlZUU7C6A/MQqs3w9GLN4ADgZloW6apbNpQWR5ItEBxG1Tms4iazLlTLsLYCW2IOTv22iNor3Il7JQzxbEKle0jsdfORj6wUy4WdaAchDEC+A1RW3MzcAVwKtW/UaiW+QiV8RWozEE+8Bu0yzBX8hbGwaiNuUeQ/xi1Q2/CTadaoA2V9Umo7EG+8Dw57/fIUxhHAs8AOwb5t9Cy8fm5WWTyYj4q+7eC/PZoOfspeRmUlzBOBn4FbBvkX0XVaLUEHDDFsxL5wG+DfAOKWHJOHsbkIYwpaAtluLRjEdol5nVO5j20tmpRkO+DAjFclLUhWQvjUhSSJYzdNA84DneyTcRHyCfmBfk64HYUbjQzshTGVOBWojUys9GoREuGNpjKoAX5xuwgXwfcQoY1R1bCmILWx4SimAWcBXyW0febyuMz5COzgnxYc0zJ4suzEMZEFKwrFMVDKAzL5oJ3GCM2I195KMjXIV86Ke0vTlsYR6CRhbBPMReYjEVhus9mNCseRpfvg5pYR6T5pWkKYz8UNSIcfVqIzmpoTfE7TXXyGfKdhUG+H/Kt1GbI0xLGMODXKJI4aIz6m1gUpue0Ih8Kw4MORj6Wyp6ONITRADyBwjyC4hEdjwMUmN6zAUU+fDPI7458LSlafa9IQxh3oZWToP/ICcDbKXyPqU3WouDT4Q/tQcjnSkqphXEJ6lyDOk2T8TIPU3pW0n4QZzLyvZJRSmGMQislQ65C1ZwxafAEioQYchPt4xX3ilIJYygaaw5HoB5BM5XGpMmtwMNBuh/ywaGFL+8+pRBGHYpAF+7R/h2anfR+CpM2bWj1bbhNdjfki70OzVMKYVxEFM1jE955Z7Il3AkYHvoznhKsqeqtML6KIluHfB93tk32rEK+F3Iz8s0e0xth9EXVVhjZ4QkUAcKYPPg3orhV/YH76MVx3b0RxhXA3wXpdehoYPcrTF60oRN5w6PjDkQ+2iN6Kox9UOj3kAtxMDSTP2uQL4ZcA+zbkw/qiTDqULUVTsM/RDRkZkzePEy0TL0B+WrRo1Q9Eca3iEKbrKfEM47GlIBLgP8N0mPQyU5FUawwdqDz7Lajjpty4wPg6lj+RqIwTd2iWGE0Ei3zXUEKi7eMKRF3IR8F+ew1W7m2E8UI4ytEEydbUIRqH9piypWOPnoR8uFuUYwwbiKKQj4LeLmIe43Jg5eJgilsQ/tuwFbprjBGEy37+IT27TdjypmriY5aHo/OB+yS7grjulj6JzhqoKkc3gNui+X/pTs3dUcYRxMNz/4FLyc3lcfNyHdBvnxMVzd0RxiNsfQNeO+2qTw2IN8N6XKEqithjCXaFbUWuKNndhmTOzOJ1lGNoovzN7oSxrRY+jbg057bZUyu/BX1j0OmFboQti6Mkah/AVr64SXlptKZiXwZ5NsjC124NWFcGkvfHftAYyqV9bRfrXFpoQvrWpckLjwcigKl9Qc+B74ErC6hgcbkxR7Af6NNTK3Abk3Njes6XlSoxvgO0c68R7EoTPWwGvk0KLLIBUkXJQmjHu3GC5lRWruMyZ24T58zbdy1nXSQJIxxwJ5B+nVgWentMiZXliHfBvn6kR0vSBJG/JTMu0tvkzFlQdy3O53S1LHzPRht8mhA56DtTjQpYkw1MQR4h8jXd25qbvz/kdeONcZEor3cT2FRmOrlQ3S+Bsjn2x1f1lEYZ8TSD6RolDHlwP2x9JnxN+JNqWHAu2h892NgZ7wExFQ3A4H3ge3QkQK7NjU3roH2NcaJRJHb5mNRmOrnU+TroEMvw8147YQxIZaeizG1QdzXTwwTYVNqAOpoD0Q99GGoOWVMtTMIRTBsQBHThzQ1N24Ma4zDkCgAFmNRmBqhqbnxI+C5IDsAOByiplR85m9BhnYZUw48FUsfCcnCeCYzc4wpD+I+Pw7UxxiOhqzq0HDtbgk3GlOVNDUrpMG0cde+A+yKjhPYuR7F2QknM57PxTpj8ifsZ9QBh9ajYGohS7O3x5iyIL6KfFQ9cHDsBQvD1Cpx3z+4LzAHnV3Whg75M6YWWQVciZpSrYX2fBtTE4Sd746U4pxvY6oOC8OYBCwMYxKwMIxJwMIwJgELw5gELAxjErAwjEnAwjAmAQvDmAQsDGMSsDCMScDCMCYBC8OYBCwMYxKwMIxJwMIwJgELw5gELAxjErAwjEnAwjAmAQvDmAQsDGMSsDCMScDCMCYBC8OYBCwMYxKwMIxJwMIwJgELw5gELAxjErAwjEnAwjAmAQvDmAQsDGMSsDCMScDCMCYBC8OYBCwMYxLoC1wKNABtwC3A5lwtMiYHpo27tg/wPaAOaO0LnAqMCt5fAPw2J9uMyZMRwI+D9PJ6YEXszW9kb48xZUHc91fUA8sKvGlMLTE6ll5eDyxF/QuAMdnbY0xZMDb4tw1YUg+sAVYGL+6K2lrG1AzTxl07Avk+wMqm5sY14XBtc+y6o7I1y5jcift8M0TzGM/E3jgmM3OMKQ+OjaWfBahrXVIHMABYBwwEWoBhwMdZW2dMDgxC3YkGYCMwpKm5cWNYY2wEng7SDcBx2dtnTC4ci3weYEFTc+NGaL8k5IlY+qSsrDImZ+K+/qsw0VEYnwfpE1GzyphqZgDyddBSqMfDN+LCWAssCtLbAeMzMc2Y/DgB+TrAwqbmxjXhGx1X194fS5+WtlXG5MyZsfQD8Tc6CmMuGpUCOB4YkqJRxuTJEOTjIJ9/LP5mR2GsR+IA9dS/lappxuTHZKLRqLlNzY3r428mbVS6N5Y+Ny2rjMmZuG/f2/HNJGE8C7wZpPel/apDY6qB0cBXg/SbBLPdcZKEsQW4J5a/pORmGZMvcZ++p6m5cUvHCwrt+f53ok74N4E9SmyYMXmxB/JpgFbk650oJIx1wOwg3Rf4bklNMyY/LkY+DfBgU3PjuqSLthYl5LZY+lxg+xIZZkxeDAbOi+VvK3Th1oTxCtHCwu2BC3tvlzG5chHRD/wzyMcT6SquVFMsfRleP2Uql4HIh0Ou39rFXQnjOWB5kB4GTO25XcbkylTkwyCfXrSVa7sViXB6LH0VaqcZU0kMRr4b8qOubuiOMBagmgNgR+Dy4u0yJle+j3wX5MtPdXVDd2PX/iCWvhzYpTi7jMmNXVAY2pAfFLowTneFsZRoh9+2dNFxMaaMuB75LMiHl3bnpmKinf8T8FmQngwcUMS9xuTBAchXQb57RXdvLEYYvwNmxu77aZH3G5MlHX10JvBGMTcXw3S0BRbgYNrPIhpTTpyHfBS0xGn6Vq7tRLHC+AtqUoVcD+xU5GcYkzbDad8PvgL5brfpSVPoP4iGb3cA/rUHn2FMmsxAvgnwPPDzYj+gJ8JoQ+umwmXppwGn9OBzjEmDU4gCebQgX20rfHkyPe08/xft22wzUfVlTJ4MB+6I5acDr/fkg3ozqnQj8FKQHgbchc4vMyYP6pAPhj/QLyMf7RG9EcbnwLeBTUF+Al6abvLjQuSDoCbUPxBF1iya3s5DvEb7SZNbgP16+ZnGFMsI4OZY/irkmz2mFBN0twPzg3R/YA4KrW5MFgxCPjcgyD9JCUZKSyGMNmAK8E6Q/wqK0+P+hkmbOhTRZu8g/w5qQhU9CtWRUi3pWIuGyFqD/MnoMHFj0uRyoqmCVuSDawpf3n1KudZpGe1nxW/AEdNNeownOrAe5HvLClxbNKVeBDgD+EWQ7gPMwp1xU3r2Q77VJ8j/AvleyUhjdex5wItBejA6pWb3FL7H1CbD0AEv4RbrF0lhMWsawtiExpPfDvJfAH6N94qb3jMYhXTaM8i/jXxtU6Ebekpa+ynWoLMHNgT5/YBHgX4pfZ+pfvohH9o/yG9APlaSznZH0txotBLFCA1Hqo5AYT8tDlMs2yDfOSLItyLfWpnWF6a9A28hcBY6+A90Qma802RMV/RBnevwdNXN6IiwhWl+aRZbUx8GvkM06TIJuA+Lw3RNH+Qrk4J8G3A+8EjaX5zVnu170JkEoTgmA79EVaQxSWyDaoowmEEb8qFOpx+lQZbBDG5HM5WhOE4DHsJ9DtOZfsg3Tg/ybSho2u1ZGZB1lI/bUFUY73M8hRcdmohBaCFg2KdoQ+ez3JqlEXmEv7mb9uuqDkd7yB3d0OyMfCEcfdqMfkjvKHhHSuQVF+oR4ETgr0F+fxSB2stHapcRwAtE8xQtwBnohzRz8gyY9gxwJFFYkz3RIrAT8jLI5MYJ6IdxzyC/HjgO7bPIhbwjCa4ADgNWB/ntgHlopaT3c1Q/dahTPQ+VPcgXxtLF+RVpk7cwQLOXB6FqFDR2fSPeCVjthDvvbiKa01qBfOHVvIwKKQdhALyPOly/jL12Mlo5OSIXi0yajEBle3LstfvRQMz7uVjUgXIRBmiF5NnAPxJFVd8bhei5CDetqoE6VJYvEW1H/QyV+VmksEq2p5STMEJmoF+OcA95fzRcNxcHdatkhqMyvAOVKaiMD6PEm4xKQTkKAzQ6NRJtcgqZgPojp+ZikekNp6CymxB7bT4q4+WJd+RMuQoDFGBhPKpmwyp2OFoqMBtHWa8EhgMPok52WNtvQjPZE4iOlCg7ylkYoOUAM4ADaX9Y+SQUP/d8yv//UIvUo7J5gyjAMqgMD0Rrnnod4iZNKsWpVqFhvEaipSQ7AHcCS1CVbMqDkahM7iQKxd+Kyu4gVJZlT6UIAzR6MZ3owYeMQgF878HrrfJkF1QGL6MyCQl/uKYTjTaWPZUkjJDX0czoFHSEFOj/MQX4PXAtDryQJYPRM/89KoPQp9YF+bH0MBR/nlSiMEDt0/vQWPhMoqjW2wLXAH9Ey0oG5mJdbTAQPeM/omceHhn8OSqTfVAZlXVfohCVKoyQD4GpwNdQiJ6QoWhZyZ+BaXhpSSkZhJ7pn9EzHhp770lUFlOJavOKpNKFEfI6WqF5KO37H8OB69DCtBtQjCvTM76ADnxcjZ5pfLJ1CXr2x1OBzaYkqkUYIUuBMcAxRIsSQe3gK4E/oTmQ0dmbVrGMRs/sT+jciXj/bQVwLHrmS7M3LT2qTRghT6ORkcODdEhfNAeyFB0schmwY+bWlT9D0LN5DT2rSejZhTyNnu0hwILMrcuAahVGyGJUe3wdHWnbEntvX7SP+F3gMbTUZAC1ywAkgMfQGqZb0TMKaUHP8OvomS7O1rxsqWtdUlOLVoejGdnzgD0S3v8IreGZi4I0fJydabmwHWoKTUR9tKRBitXo0MefkVI4zDxpam5MfL3WhBFSj/Z/nI/W7DQkXNOCdpE9jbbhVsSMbTcYARwFHI2aQ4X+748jQTQDWzKzLmMKCaNv4qvVzxbg2eBve/SLeTowjmg3WQP6NT02yL+Lmg/Lgr9VRGGAypU+SAijg7/DgF0LXLsZiWA2Cp68PgP7ypZarTEKMQzVIOPRr+rWJgivRkPA5cxVaIi1EJ+i2vAJVEOU7WrXtHCN0T3WovU+96DO6OEoksk4FNqn0n9F2tC+iGZUWy4CNuZqUZliYRRmI5pND2fUd0JDwKPRMGVLgfvKiRa0EegF1PxbDnyQq0UVwv8BNYmwIpIWBvwAAAAASUVORK5CYII="
            let data = []
            let color = [
                "#0b5263",
                "#00cfff",
                "#006ced",
                "#ffe000",
                "#ffa800",
                "#ff5b00",
                "#ff3000",
                "#50b7c1",
                "#b69968",
                "#6950a1",
            ]
            for (var i = 0; i < trafficWay.length; i++) {
                data.push(
                    {
                        value: trafficWay[i].value + 10,
                        name: trafficWay[i].name,
                        itemStyle: {
                            normal: {
                                borderWidth: 3,
                                shadowBlur: 10,
                                borderColor: color[i],
                                shadowColor: color[i],
                            },
                        },
                    },
                    {
                        value: 2,
                        name: "",
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false,
                                },
                                labelLine: {
                                    show: false,
                                },
                                color: "rgba(0, 0, 0, 0)",
                                borderColor: "rgba(0, 0, 0, 0)",
                                borderWidth: 0,
                            },
                        },
                    }
                )
            }
            let seriesOption = [
                {
                    name: "",
                    type: "pie",
                    clockWise: false,
                    radius: [65, 60],
                    hoverAnimation: false,
                    itemStyle: {
                        normal: {
                            label: {
                                show: true,
                                position: "outside",
                                color: "#ddd",
                                formatter: function (params) {
                                    var percent = 0
                                    var total = 0
                                    for (
                                        var i = 0;
                                        i < trafficWay.length;
                                        i++
                                    ) {
                                        total += trafficWay[i].value
                                    }
                                    percent = (
                                        (params.value / total) *
                                        100
                                    ).toFixed(0)
                                },
                            },
                        },
                    },
                    data: data,
                },
            ]
            let option = {
                color: color,
                title: {
                    text: "老人类别",
                    top: "48%",
                    textAlign: "center",
                    left: "49%",
                    textStyle: {
                        color: "#fff",
                        fontSize: 14,
                        fontWeight: "400",
                    },
                },
                graphic: {
                    elements: [
                        {
                            type: "image",
                            z: 3,
                            style: {
                                image: img,
                                width: 80,
                                height: 80,
                            },
                            left: "center",
                            top: "center",
                            position: [100, 100],
                        },
                    ],
                },
                tooltip: {
                    show: true,
                    formatter: function (params, ticket, callback) {
                        return `${params.name}:${params.value - 10}`
                    },
                },
                toolbox: {
                    show: false,
                },
                series: seriesOption,
            }
            self.echartOne.setOption(option, true)
        },
        // 改造人数统计echarts
        echartsTwo(nameList, seriesData) {
            let self = this
            self.echartTwo = self.$echarts.init(
                document.getElementById("echartsTwo")
            )
            let option = {
                color: ["#08aeec"],
                title: {
                    show: false,
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    show: false,
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    top: "15%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: nameList,
                    axisLabel: {
                        textStyle: {
                            color: "#ffffff",
                            fontSize: 10,
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    splitLine: {
                        //网格线
                        lineStyle: {
                            type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
                        },
                        show: true, //隐藏或显示
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#ffffff",
                        },
                    },
                },
                series: [
                    {
                        name: "人数",
                        type: "line",
                        stack: "总量",
                        smooth: true,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    color: "#08aeec",
                                },
                            },
                        },
                        data: seriesData,
                    },
                ],
            }
            self.echartTwo.setOption(option, true)
        },
        // 改造产品统计echarts
        echartsThree(productName = [], productDate = []) {
            let self = this
            self.echartThree = self.$echarts.init(
                document.getElementById("echartsThree")
            )
            let option = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    show: false,
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: "40%",
                        center: ["50%", "38%"],
                        data: productDate,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            // 设置图表的参数
            self.echartThree.setOption(option, true)
        },
        // 自理类别统计echarts
        echartsFour(selfDate = []) {
            let self = this
            self.echartFour = self.$echarts.init(
                document.getElementById("echartsFour")
            )
            let option = {
                color: ["#32A5A1"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "none",
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "4%",
                    top: "15%",
                    containLabel: true,
                },
                xAxis: [
                    {
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            color: "#fff",
                            rotate: 25,
                        },
                        textStyle: {
                            fontSize: 5,
                        },
                        data: [
                            "自理",
                            "失能",
                            "半失能",
                            "失智",
                            "轻度依赖",
                            "重度依赖",
                            "不能自理",
                        ],
                    },
                ],
                yAxis: {
                    splitLine: {
                        //网格线
                        lineStyle: {
                            type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
                        },
                        show: true, //隐藏或显示
                    },
                    axisLabel: {
                        color: "#fff",
                    },
                    nameTextStyle: {
                        color: "#fff",
                    },
                    type: "value",
                    data: [
                        "0",
                        "3",
                        "6",
                        "9",
                        "12",
                        "15",
                        "18",
                        {
                            textStyle: {
                                color: "#fff",
                            },
                        },
                    ],
                },
                series: {
                    name: "",
                    type: "bar",
                    barWidth: "20%",
                    data: selfDate,
                },
            }
            self.echartFour.setOption(option, true)
        },
        // 项目状态数据获取
        project() {
            this.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/projectStatusStatistics",
                    method: "POST",
                    data: {},
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content != null) {
                            this.state = res.content
                        }
                    }
                })
        },
        //老人类别统计数据获取
        getInformation() {
            this.gettypeList()
            request({
                url: "/jjyl/admin/elderlyInformation/info/elderlyCategoriesStatistics",
                method: "POST",
            }).then((res) => {
                if (res.code == 200) {
                    let trafficWay = []
                    // let refer = [
                    //     { oldType: 0, label: "特困老人" },
                    //     { oldType: 1, label: "低保老人" },
                    //     { oldType: 2, label: "建档立卡贫困老人" },
                    //     { oldType: 3, label: "优抚对象" },
                    //     { oldType: 4, label: "失独老人" },
                    //     { oldType: 5, label: "残疾老人" },
                    //     { oldType: 6, label: "计划生育特殊家庭成员" },
                    //     { oldType: 7, label: "空巢老人" },
                    //     { oldType: 8, label: "农村留守老人" },
                    //     { oldType: 9, label: "80岁以上老人" },
                    //     { oldType: 10, label: "其他" },
                    // ]
                    res.content.forEach((item) => {
                        this.oldTypeList.forEach((child) => {
                            if (item.oldType == child.dictCode) {
                                trafficWay.push({
                                    value: item.number,
                                    name: child.dictLabel,
                                })
                            }
                        })
                    })
                    console.log(trafficWay, "trafficWay")
                    this.echartsOne(trafficWay)
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
        // 改造人数统计数据获取
        async number() {
            await request({
                url: "/jjyl/admin/elderlyInformation/info/reformPersonNumStatistics",
                method: "POST",
            }).then((res) => {
                if (res.code == 200) {
                    // this.personNum = res.content
                    // this.echartsTwo(this.personNum)
                    //   for (let key in content) {
                    //     this.nameList.push(key);
                    //     this.seriesData.push(content[key]);
                    //   }
                    this.nameList = res.content.map((isat) => {
                        if (isat.yuefen) {
                            return isat.yuefen
                        }
                    })
                    this.seriesData = res.content.map((isat) => {
                        if (isat.yuefen) {
                            return isat.number
                        }
                    })
                    this.echartsTwo(this.nameList, this.seriesData)
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
        handleSearch(sign = "", id = "") {
            let self = this
            this.isLoading = true
            // this.isLoading = true;
            // if(sign === 'search' && this.keyword.trim() === "") {
            //   this.isLoading = false
            //   return;
            // }
            let data = {
                pageNo: 1,
                pageSize: 10000,
                customerName: this.keyword,
            }
            if (id !== "") {
                data.name = ""
                data.approvalStatus = id
            }
            request({
                url: "/jjyl/admin/elderlyInformation/info/findList1",
                method: "POST",
                data,
            }).then((res) => {
                this.isLoading = false
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                        if (self.infoTisp == false) {
                            self.infoTisp = true
                            setTimeout(() => {
                                self.infoTisp = false
                            }, 3000)
                        }
                        this.isLoading = false
                        return
                    }
                    if (res.content.list == null) {
                        if (this.infoTisp == false) {
                            this.infoTisp = true
                            setTimeout(() => {
                                self.infoTisp = false
                            }, 3000)
                        }
                        this.isLoading = false
                        return
                    }
                    this.map.remove(this.markers)
                    this.markers = []
                    let data = res.content.list.filter(
                        (item) => item.longitude && item.latitude
                    )
                    this.renderMapMarker(data)
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
        //获取改造信息数据
        getFormationInfo() {
            // self.checkForm.balconyPhoto = data.balconyPhoto //阳台
            // self.checkForm.bedroomPhoto = data.bedroomPhoto //卧室
            // self.checkForm.kitchenPhoto = data.kitchenPhoto //厨房
            // self.checkForm.livingRoomPhoto = data.livingRoomPhoto //客厅
            // self.checkForm.toiletPhoto = data.toiletPhoto //卫生间
            // self.checkForm.balconyAfterPhoto = data.balconyAfterPhoto //阳台改造后
            // self.checkForm.bedroomAfterPhoto = data.bedroomAfterPhoto //卧室改造后
            // self.checkForm.kitchenAfterPhoto = data.kitchenAfterPhoto //厨房改造后
            // self.checkForm.livingRoomAfterPhoto = data.livingRoomAfterPhoto //客厅改造后
            // self.checkForm.toiletAfterPhoto = data.toiletAfterPhoto //卫生间改造后
            request({
                url: "/jjyl/admin/elderlyInformation/info/findList1",
                method: "POST",
                data: {
                    pageNo: 1,
                    pageSize: 10000,
                    approvalStatus: 8,
                },
            }).then((res) => {
                console.log(res)
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                        return
                    }
                    if (
                        res.content.list == null ||
                        res.content.list.length == 0
                    ) {
                        return
                    }
                    this.formationInfoList = res.content.list
                    // var tempElderlySubProManageList = [] = []
                    console.log(
                        this.formationInfoList,
                        "this.formationInfoList"
                    )
                    this.formationInfoList.forEach(async (item) => {
                        this.$set(item, "detailAddress", item.address)
                    })
                    let item1 = this.formationInfoList[0]
                    this.changePhoto(item1) //默认显示第一个
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
        changePhoto(item) {
            console.log(item, "oooooo")
            this.elderlySubProManageList = []
            if (item.balconyPhoto && item.balconyAfterPhoto) {
                this.elderlySubProManageList.push({
                    before: item.balconyPhoto,
                    after: item.balconyAfterPhoto,
                })
            }
            if (item.bedroomPhoto && item.bedroomAfterPhoto) {
                this.elderlySubProManageList.push({
                    before: item.bedroomPhoto,
                    after: item.bedroomAfterPhoto,
                })
            }
            if (item.kitchenPhoto && item.kitchenAfterPhoto) {
                this.elderlySubProManageList.push({
                    before: item.kitchenPhoto,
                    after: item.kitchenAfterPhoto,
                })
            }
            if (item.livingRoomPhoto && item.livingRoomAfterPhoto) {
                this.elderlySubProManageList.push({
                    before: item.livingRoomPhoto,
                    after: item.livingRoomAfterPhoto,
                })
            }
            if (item.toiletPhoto && item.toiletAfterPhoto) {
                this.elderlySubProManageList.push({
                    before: item.toiletPhoto,
                    after: item.toiletAfterPhoto,
                })
            } else if (
                item.elderlySubProManageList &&
                item.elderlySubProManageList.length > 0
            ) {
                item.elderlySubProManageList.forEach((child) => {
                    if (child.reformBeforePhoto && child.reformAfterPhoto) {
                        this.elderlySubProManageList.push(child)
                    }
                })
            }
            if (item.elderlyPhotoList != null) {
                item.elderlyPhotoList.forEach((item) => {
                    item.photo = item.photo.split("#")[0]
                    // var qq = []
                    // this.qq = item.photo.concat(item.photo)
                    item.afterphoto = item.afterphoto.split("#")[0]
                    this.elderlySubProManageList.push({
                        before: item.photo,
                        after: item.afterphoto,
                    })
                    // var arr2 = []
                    // for (let i = 0; i < item.photo.length; i++) {
                    //     arr2.push({
                    //         beforephoto: item.photo[i],
                    //         afterphoto: item.afterphoto[i],
                    //     })
                    // }
                    // arr2.forEach((item1) => {
                    //     this.elderlySubProManageList.push({
                    //         before: item1.beforephoto,
                    //         after: item1.afterphoto,
                    //     })
                    // })
                })
                console.log(
                    this.elderlySubProManageList,
                    "this.elderlySubProManageList"
                )
            }
        },
        // 获取老人全程问题
        getElderlyInformation(id) {
            let self = this
            self.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/finished",
                    method: "POST",
                    data: {
                        id,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null && res.content == "null") return
                        self.elderlyInformationList = res.content
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        //获取服务商列表
        getServiceProvider() {
            this.$http
                .request({
                    url: "/jjyl/admin/serviceProvider/info/findList",
                    method: "POST",
                    data: { pageNo: 1, pageSize: 1000 },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.providerList = []
                            return
                        }
                        this.providerList = res.content.list
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        //获取施工员列表
        getServiceProviderPerson(id) {
            this.$http
                .request({
                    url: "/jjyl/admin/serviceProviderPersons/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 1000,
                        serviceProviderId: id,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.providerPersonList = []
                            return
                        }
                        res.content.list.forEach((item) => {
                            item.id = String(item.id)
                        })
                        this.providerPersonList = res.content.list
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        //获取老人信息
        getById(id) {
            // this.gettypeList()
            let self = this
            self.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/getById",
                    method: "POST",
                    data: {
                        id: id,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        let data = res.content
                        self.checkForm.assessConfirmation =
                            data.assessConfirmation //评估单
                        self.checkForm.straightArmrestBefore =
                            data.straightArmrestBefore //扶手改造前
                        self.checkForm.straightArmrestAfter =
                            data.straightArmrestAfter //扶手改造后
                        self.checkForm.smokeDetectorBefore =
                            data.smokeDetectorBefore //烟雾报警器改造前
                        self.checkForm.smokeDetectorAfter =
                            data.smokeDetectorAfter //烟雾报警器改造后
                        self.checkForm.leader = data.leader //负责人

                        self.checkForm.balconyPhoto = data.balconyPhoto //阳台
                        self.checkForm.bedroomPhoto = data.bedroomPhoto //卧室
                        self.checkForm.kitchenPhoto = data.kitchenPhoto //厨房
                        self.checkForm.livingRoomPhoto = data.livingRoomPhoto //客厅`
                        self.checkForm.toiletPhoto = data.toiletPhoto //卫生间
                        self.checkForm.balconyAfterPhoto =
                            data.balconyAfterPhoto //阳台改造后
                        self.checkForm.bedroomAfterPhoto =
                            data.bedroomAfterPhoto //卧室改造后
                        self.checkForm.kitchenAfterPhoto =
                            data.kitchenAfterPhoto //厨房改造后
                        self.checkForm.livingRoomAfterPhoto =
                            data.livingRoomAfterPhoto //客厅改造后
                        self.checkForm.toiletAfterPhoto = data.toiletAfterPhoto //卫生间改造后

                        self.checkForm.serviceProviderName =
                            data.serviceProviderName //施工单位
                        if (!data.serviceProviderPersonList) {
                            data.serviceProviderPersonList = []
                        }
                        self.checkForm.serviceProviderId =
                            data.serviceProviderId
                        self.getServiceProviderPerson(
                            self.checkForm.serviceProviderId
                        )
                        self.checkForm.serviceProviderPersonId =
                            data.serviceProviderPersonId.split(",")
                        console.log(
                            self.checkForm.serviceProviderPersonId,
                            "self.checkForm.serviceProviderPersonId"
                        )
                        data.serviceProviderPersonList =
                            data.serviceProviderPersonList.join(",")
                        self.checkForm.serviceProviderPersonList =
                            data.serviceProviderPersonList
                        self.checkForm.elderlySubProManageList =
                            data.elderlySubProManageList
                        self.formData.customerName = data.customerName
                        self.formData.gender = data.gender == 0 ? "男" : "女"
                        self.formData.age = data.age
                        self.formData.idCard = data.idCard
                        self.formData.phone = data.phone
                        self.formData.elderlyBelongCategory =
                            data.elderlyBelongCategory
                        self.oldTypeList.forEach((item) => {
                            if (
                                item.dictCode ==
                                self.formData.elderlyBelongCategory
                            ) {
                                self.formData.elderlyBelongCategory =
                                    item.dictLabel
                            }
                        })
                        self.imageUrl = data.photo
                        self.currentApprovalStatus = data.approvalStatus
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        renderMapMarker(data) {
            let self = this
            var endIcon = new AMap.Icon({
                size: new AMap.Size(49, 56),
                image: require("../assets/img/end_icon.png"),
                imageSize: new AMap.Size(38, 42),
            })
            data.forEach((item) => {
                let marker = new AMap.Marker({
                    position: [item.longitude, item.latitude],
                    icon: endIcon,
                })

                self.markers.push(marker)
                marker.on("mouseover", (e) => {
                    marker.setTitle(item.name)
                })
                marker.on("click", (e) => {
                    self.dialogVisible = true
                    self.getElderlyInformation(item.id)
                    self.getById(item.id)
                })
            })
            self.map.add(self.markers)
            self.map.add(self.polygon)
            self.map.setFitView(self.polygon) //视口自适应
        },
        //循环遍历地址
        async loopAddress() {},
        // 改造产品数据获取
        async produce() {
            let that = this
            await request({
                url: "/jjyl/admin/elderlyInformation/info/projectType",
                method: "POST",
                data: {
                    pageNo: 1,
                    pageSize: 10,
                },
            }).then((res) => {
                if (res.code == 200) {
                    res.content.forEach((item) => {
                        if (item.projectName) {
                            that.productDate.push({
                                value: item.num,
                                name: item.projectName,
                            })
                        }
                    })
                    console.log(that.productDate, "that.productDate")
                }
            })
            // trafficWay.push({
            //         value: item.number,
            //         name: child.label,
            //       });
            //    currentList.map((item) => {
            //         request({
            //             url: "/jjyl/admin/projectManage/info/getById",
            //             method: "POST",
            //             data:{
            //               id:item.id
            //             }
            //           }).then((res) => {
            //             if (res.code == 200) {
            //              that.productDate.push({
            //                 value: res.content.subProManageList.length > 0 ?  res.content.subProManageList.length : 0,
            //                 name:  res.content.projectName,
            //               })
            //             }
            //           });
            //     });
            //   } else if (res.code == "10004") {
            //     this.$message.error(res.message);
            //     this.$router.push("/login");
            //   }
            // });
            setTimeout(function () {
                that.echartsThree(that.productName, that.productDate)
            }, 2000)
        },
        // 自理类别数据获取
        async selfType() {
            let that = this
            await request({
                url: "/jjyl/admin/elderlyInformation/info/selfCareCategoryStatistics",
                method: "POST",
            }).then((res) => {
                if (res.code == 200) {
                    that.selfDate = res.content.reduce((prve, item) => {
                        prve.push(item.name)
                        return prve
                    }, [])
                    this.echartsFour(that.selfDate)
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
        // 老人评价数据获取
        async service() {
            await request({
                url: "/jjyl/admin/elderlyInformation/info/elderlyEvaluate",
                method: "POST",
                data: {
                    replySelection: 0,
                },
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "") {
                        return
                    }
                    this.textList = res.content
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
        init() {
            this.project()
            this.number()
            this.produce()
            this.selfType()
            this.service()
            this.getInformation()
            this.getFormationInfo()
            this.handleSearch()
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                this.map = new AMap.Map("container", {
                    resizeEnable: true,
                    _mapStyle: "amap://styles/darkblue",
                    get mapStyle() {
                        return this._mapStyle
                    },
                    set mapStyle(value) {
                        this._mapStyle = value
                    },
                    zoom: 9,
                })
                if (
                    this.$store.state.orgAreaLevel == 1 ||
                    this.$store.state.orgAreaLevel == 2 ||
                    this.$store.state.orgAreaLevel == 3
                ) {
                    let cities = [this.$store.state.orgAreaName]
                    for (let i = 0; i < cities.length; i++) {
                        this.areaBG(this.map, cities[i])
                        this.map.setZoom(8)
                    }
                } else if (
                    this.$store.state.orgAreaLevel == 4 ||
                    this.$store.state.orgAreaLevel == 5
                ) {
                    console.log("社区，街道", this.$store.state.orgId)

                    if (this.$store.state.orgId != 0) {
                        this.$http
                            .request({
                                url: "/rbac/admin/org/info/findOrgById",
                                method: "POST",
                                data: {
                                    id: this.$store.state.orgId,
                                },
                            })
                            .then((res) => {
                                var polygonArr = []
                                res.content.pointPosition
                                    .split(",")
                                    .forEach((i) => {
                                        console.log(i)
                                        polygonArr.push(i.split(":"))
                                    })
                                this.polygon = new AMap.Polygon({
                                    map: this.map,
                                    strokeWeight: 1,
                                    path: polygonArr,
                                    fillOpacity: 0.3,
                                    fillColor: "#2191E6",
                                    strokeColor: "#007CDB",
                                })
                                this.map.setZoomAndCenter(14, [
                                    polygonArr[0].lng,
                                    polygonArr[0].lat,
                                ])
                                this.polygon.setMap(self.map)
                            })
                    }
                }
                resolve()
            })
        },
        areaBG(map, cityName) {
            console.log(cityName, "cityName")
            AMap.service("AMap.DistrictSearch", function () {
                let opts = {
                    subdistrict: 0,
                    extensions: "all",
                    level: "district", // 查询行政级别为市
                }
                // 实例化DistrictSearch
                let district = new AMap.DistrictSearch(opts)
                district.setLevel("district")
                // 行政区查询
                district.search(`${cityName}`, function (status, result) {
                    // 获取边界信息
                    let bounds = result.districtList[0].boundaries
                    let polygons = []
                    if (bounds) {
                        for (let i = 0, l = bounds.length; i < l; i++) {
                            // 生成行政区划polygon
                            let polygon = new AMap.Polygon({
                                map: map,
                                strokeWeight: 1,
                                path: bounds[i],
                                fillOpacity: 0.3,
                                fillColor: "#2191E6",
                                strokeColor: "#007CDB",
                            })
                            polygons.push(polygon)
                            console.log(polygon)
                        }
                    }
                })
            })
        },
        //获取地址
        getDistrict(name = "中国") {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 3,
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0].districtList)
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
    },
    get methods() {
        return this._methods
    },
    set methods(value) {
        this._methods = value
    },
    async mounted() {
        let self = this

        await self.loadMap()
        self.getServiceProvider()
        window.addEventListener("resize", () => {
            // 自适应所有echarts
            const handleResize = () => {
                if (!checkFull()) {
                    self.onFullScreen = false
                }
            }
            window.onresize = handleResize
            function checkFull() {
                let isFull =
                    document.fullscreenElement ||
                    document.mozFullScreenElement ||
                    document.webkitFullscreenElement
                if (isFull === undefined) isFull = false
                return isFull
            }
            self.$nextTick(() => {
                self.echartOne && self.echartOne.resize() // 老人类别统计echarts
                self.echartTwo && self.echartTwo.resize() //改造人数统计echarts
                self.echartThree && self.echartThree.resize() //改造产品统计echarts
                self.echartFour && self.echartFour.resize() //自理类别统计echarts
            })
        })
        this.init()
        let arr = [[{ week: 1 }], [{ week: 2 }, { week: 3 }], []]

        // const self = this
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    beforeDestory() {
        window.removeEventListener("resize")
    },
}
</script>

<style lang="less" scoped>
.nameoftransition-enter-active,
.nameoftransition-leave-active {
    transition: opacity 0.5s;
}
.nameoftransition-enter, .nameoftransition-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
//引入的字体样式
@font-face {
    font-family: "Unidtrsmled";
    src: url(../assets/font/UnidreamLED.ttf);
}
.bigdata_container {
    * {
        box-sizing: content-box;
    }
}
/deep/ .el-carousel__container {
    height: 100% !important;
    .el-icon-arrow-left:before,
    .el-icon-arrow-right:before {
        color: #489aff;
        font-weight: bold;
        font-size: 22px;
    }
}
.update_info {
    display: flex;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    top: 50px;
    color: #ffffff;
    font-size: 14px;
    .info_left {
        overflow-y: scroll;
        width: 50%;
        padding: 0 12px;
        &::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
        }
        .left_title {
            display: flex;
            span {
                flex: 1;
                line-height: 24px;
                &:nth-child(1) {
                    flex: 0 0 60px;
                }
            }
        }
        .left_list {
            display: flex;
            .list_item {
                flex: 1;
                line-height: 48px;
                overflow: hidden; //超出的文本隐藏
                text-overflow: ellipsis; //溢出用省略号显示
                white-space: nowrap; //溢出不换行
                .index {
                    border-radius: 50%;
                    height: 24px;
                    width: 26px;
                    background: #489aff;
                    text-align: center;
                    font-size: 14px;
                    line-height: 24px;
                    font-family: Unidtrsmled;
                }
            }
        }
    }
    .info_right {
        width: 50%;
        padding: 0 12px;
        .wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            .left {
                width: 50%;
                margin-right: 12px;
            }
            .right {
                width: 50%;
            }
            img {
                width: 100%;
                height: 148px;
            }
            .label {
                margin-bottom: 12px;
                color: #489aff;
            }
        }
    }
}
.bigdata_container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url("../assets/img/bg.png") no-repeat center center;
    background-size: 100% 100%;
    .info_tisp {
        min-width: 380px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: #ebeef5;
        position: fixed;
        left: 50%;
        top: 20px;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        background-color: #edf2fc;
        border-radius: 5px;
        -webkit-transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
        transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
        transition: opacity 0.3s, transform 0.4s, top 0.4s;
        transition: opacity 0.3s, transform 0.4s, top 0.4s,
            -webkit-transform 0.4s;
        padding: 15px;
        display: flex;
        align-items: center;
        line-height: 1;
        .el-message__icon {
            margin-right: 10px;
        }
    }
    .header {
        margin: auto;
        width: 90%;
        height: 100px;
        background: url("../assets/img/bg_header.png") no-repeat center center;
        background-size: 100%;
        text-align: center;
        line-height: 73px;
        color: #1ad4f0;
        font-size: 25px;
    }
    .bigdata_main {
        position: absolute;
        left: 0;
        top: 100px;
        right: 0;
        bottom: 0;

        .main_left {
            position: absolute;
            top: 4%;
            bottom: 5%;
            left: 20px;
            width: 22%;
            overflow-y: auto;
            .main_pane1 {
                .titleBox {
                    height: 170px;
                    overflow-y: auto;
                    &::-webkit-scrollbar {
                        width: 0 !important;
                        height: 0 !important;
                    }
                }
            }
            .main_pane2 {
                .titleBox {
                    height: 23.5vh;
                }
            }
            .main_pane3 {
                .titleBox {
                    height: 21vh;
                }
            }
            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }
        .main_center {
            position: absolute;
            top: 4%;
            bottom: 5%;
            right: 25%;
            left: 25%;
            overflow-y: auto;
            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }
        .main_right {
            position: absolute;
            top: 4%;
            bottom: 5%;
            right: 20px;
            width: 22%;
            overflow-y: auto;
            .main_pane4 {
                .titleBox {
                    height: 25vh;
                    overflow-y: hidden;
                }
            }
            .main_pane5 {
                .titleBox {
                    height: 21.7vh;
                    overflow-y: hidden;
                }
            }
            .main_pane6 {
                .titleBox {
                    overflow-y: auto;
                    height: 150px;
                    padding: 15px 10px;
                    .inline {
                        overflow-y: auto;
                        height: 150px;
                        &::-webkit-scrollbar {
                            width: 0 !important;
                            height: 0 !important;
                        }
                    }
                }
            }
            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
            }
        }
        .titleHeader {
            background: url("../assets/img/biaoti_bg_title.png") no-repeat
                center center;
            // background-size: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            .titleIcon {
                display: inline-block;
                height: 37px;

                img {
                    height: 17px;
                    width: 17px;
                    margin: 10px 10px;
                }
            }

            .titleTxt {
                font-size: 16px;
                line-height: 37px;
                color: #569cea;
            }
        }
        .iconimg {
            background: url("../assets/img/title-icon.png") no-repeat center
                center;
            background-size: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            .titleIcon {
                display: inline-block;
                height: 37px;

                img {
                    height: 17px;
                    width: 17px;
                    margin: 10px 10px;
                }
            }

            .titleTxt {
                font-size: 16px;
                line-height: 37px;
                color: #569cea;
            }
        }
        .titleBox {
            width: 100%;
            padding: 0 12px;
            box-sizing: border-box;
            border: 1px solid #1b3074;
            ul {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                li {
                    margin-top: 20px;
                    width: 25%;
                    color: #ffffff;
                    text-align: center;
                    line-height: 1;
                    .bgimg {
                        font-family: Unidtrsmled;
                        font-size: 16px;
                        background: url("../assets/img/9.png") no-repeat center
                            center;
                        background-size: 100%;
                        display: inline-block;
                        border-radius: 5px;
                        color: #02e0e4;
                        width: 70%;
                        height: 30px;
                        line-height: 30px;
                        margin-bottom: 5px;
                        cursor: pointer;
                    }

                    p {
                        font-family: "Unidtrsmled";
                        margin-top: 6px;
                        font-size: 12px;
                    }
                }
            }

            .li {
                padding-left: 4px;
                font-size: 14px;
                display: flex;
                margin-top: 10px;
                flex-direction: row;
                color: #fff;
                line-height: 24px;
                .img {
                    border-radius: 50%;
                    height: 24px;
                    width: 26px;
                    background: #489aff;
                    text-align: center;
                    font-size: 14px;
                    font-family: Unidtrsmled;
                }
                .txt {
                    margin-left: 20px;
                    width: 52%;
                    overflow: hidden;
                    height: 18px;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                    text-align: center;
                }
                .time {
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                }
            }
        }

        .flex1 {
            display: flex;
            flex-direction: column;
        }

        .map {
            position: relative;
            margin-top: 30px;
            text-align: center;
            color: #4ac3ff;
            height: 37.5vh;
            padding: 0 24px;
            background: url("../assets/img/tc.png") no-repeat center center;
            background-size: 100% 100%;
            /deep/ .serach_wrapper {
                z-index: 100;
                position: absolute;
                left: 50%;
                top: 50px;
                transform: translateX(-50%);
                .el-button {
                    color: #0291c2;
                    background: #041d4d;
                    border: none;
                }
                .el-input__inner {
                    color: #0291c2;
                    background: #102132;
                    border-color: #233b87;
                }
            }
            .title_wrap {
                position: absolute;
                top: -0%;
                left: 50%;
                font-weight: bold;
                transform: translateX(-50%);
            }
            // .map_title {
            // position: absolute;
            // left: 0;
            // top: 0;
            // width: 100%;
            // height: 24px;
            // background: url("../assets/img/tc.png") no-repeat center top;
            // background-size: 100% 100%;
            // &::after {
            // position: absolute;
            // left: 0;
            // top: 0;
            // right: 0;
            // bottom: 0;
            // content: '';
            // background: red;
            // }
            // }
            &:nth-child(1) {
                position: relative;
                top: -10px;
                position: relative;
                padding: 30px 3px 5px;
                box-sizing: border-box;
                overflow: hidden;
                .map_wrapper {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    background: url("../assets/img/tc.png") no-repeat center
                        center;
                    background-size: 100% 100%;
                }
            }
            &:nth-child(1) {
                margin-top: 20px;
            }
        }
    }
    .quanp {
        width: 200px;
        height: 100px;
        float: right;
        position: absolute;
        top: 20px;
        right: -110px;
        z-index: 100;
        button {
            padding: 10px;
        }
    }
}

// 弹框步骤条样式
/deep/ #el-step {
    margin-bottom: 30px;
    .el-step__icon.is-text {
        border-radius: 5px;
    }
    .is-finish .el-step__icon {
        background: #409eff;
    }
    .el-step__icon {
        width: auto;
        padding: 22px 38px;
        color: #ffffff;
        cursor: pointer;
        border: none;
        background: #c0c4cc;
    }
    .el-step {
        height: 40px;
        margin-bottom: 24px;
    }
    .el-step.is-horizontal .el-step__line {
        top: 20px;
    }
}
.check_form_item {
    img {
        width: 100px;
        height: 100px;
    }
}
.el-step.is-center /deep/.el-step__line {
    right: -27%;
    left: 73%;
    border-top: 1px solid #c8b226;
    background-color: transparent;
}
/deep/ .check_form_item,
/deep/ .acceptance_form_item {
    display: flex;
    flex-direction: column;
    .el-form-item__label {
        width: 100% !important;
        margin-bottom: 12px;
        text-align: left;
        border-bottom: 1px solid #c0c4cc;
    }
    /deep/ .el-form-item__content {
        margin-left: 0 !important;
    }
}
.user_info {
    /deep/ .el-form-item {
        margin-bottom: 20px;
    }
}

// /deep/ .check_form_item {
//   display: flex;
// }
.check_upload {
    display: inline-block;
    & + .check_upload {
        margin-left: 12px;
    }
    .avatar-uploader {
        line-height: 1;
    }
    .photo {
        font-size: 0;
        img {
            width: 100px;
            height: 100px;
        }
    }
    /deep/ .el-button {
        width: 100px;
        padding: 0;
        line-height: 35px;
        margin-top: 5px !important;
    }
}
.photo {
    font-size: 0;
    img {
        width: 160px;
        height: 160px;
    }
}
/deep/.el-dialog {
    background: #092267;
    opacity: 0.8;
}
#el-step /deep/.el-step__icon {
    background: none;
    color: #c8b226;
    border: 1px solid #c8b226;
}
#el-step /deep/.is-finish .el-step__icon {
    background: #c8b226;
    color: #fff;
}
/deep/.dialog_container .el-dialog__footer {
    background: #092267;
    border-top: none;
    opacity: 0.8;
    text-align: center;
    .el-button {
        border: 1px solid #4a93dc;
        color: #fff;
        margin-bottom: 8px;
        background: #092267;
    }
    .el-button:hover {
        background: #092267;
    }
}
/deep/.el-form-item__label {
    color: #fff;
}
.el-input.is-disabled /deep/.el-input__inner {
    background-color: #85b6db;
    color: #fff;
    opacity: 0.55;
    border: none;
}
.el-textarea.is-disabled /deep/.el-textarea__inner {
    background-color: #85b6db;
    color: #fff;
    border: none;
    opacity: 0.55;
}
/deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #092267;
    border-color: #409eff;
}
/deep/.el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #092267;
    border-color: #409eff;
}
.assessment_upload {
    height: auto;
    width: 100%;
    overflow: hidden;
    position: relative;
    ul {
        width: auto;
        height: auto;
        overflow-x: scroll;
        overflow-y: hidden;
        display: flex;
        justify-content: space-between;
        li {
            margin-left: 20px;
            width: 150px;
            .avatar-uploader {
                width: 100%;
                img {
                    width: auto;
                    min-width: 160px;
                    height: 120px;
                }
            }
            .el-button {
                width: 100%;
            }
            &:nth-child(1) {
                margin-left: 0;
            }
        }
    }
}
</style>
